"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.omnibus = omnibus;
exports.OmnibusLine = void 0;

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));

var omnibusLines = new _map.default();

var OmnibusLine = /*#__PURE__*/function () {
  function OmnibusLine(name) {
    (0, _classCallCheck2.default)(this, OmnibusLine);
    this.name = void 0;
    this.listeners = new _map.default();
    this.name = name;
  }

  (0, _createClass2.default)(OmnibusLine, [{
    key: "on",
    value: function on(event, handler) {
      var _this$listeners$get,
          _this = this;

      var listeners = (_this$listeners$get = this.listeners.get(event)) !== null && _this$listeners$get !== void 0 ? _this$listeners$get : new _set.default();
      listeners.add(handler);
      this.listeners.set(event, listeners);
      return function () {
        return _this.off(event, handler);
      };
    }
  }, {
    key: "off",
    value: function off(event, handler) {
      var _this$listeners$get2;

      var listeners = (_this$listeners$get2 = this.listeners.get(event)) !== null && _this$listeners$get2 !== void 0 ? _this$listeners$get2 : new _set.default();
      listeners.delete(handler);

      if (listeners.size === 0) {
        this.listeners.delete(event);
      }
    }
  }, {
    key: "dispatch",
    value: function dispatch(event, detail) {
      var broadcast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var listeners;

      if (broadcast) {
        var _omnibusLines$get;

        var lines = (0, _toConsumableArray2.default)((_omnibusLines$get = omnibusLines.get(this.name)) !== null && _omnibusLines$get !== void 0 ? _omnibusLines$get : []);
        listeners = (0, _reduce.default)(lines).call(lines, function (out, line) {
          var _context, _line$listeners$get;

          return (0, _concat.default)(_context = []).call(_context, (0, _toConsumableArray2.default)(out), (0, _toConsumableArray2.default)((_line$listeners$get = line.listeners.get(event)) !== null && _line$listeners$get !== void 0 ? _line$listeners$get : []));
        }, []);
      } else {
        var _this$listeners$get3;

        listeners = (0, _toConsumableArray2.default)((_this$listeners$get3 = this.listeners.get(event)) !== null && _this$listeners$get3 !== void 0 ? _this$listeners$get3 : []);
      }

      var _iterator = (0, _createForOfIteratorHelper2.default)(listeners),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var iterator = _step.value;
          iterator(detail, event);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.listeners.size === 0;
    }
  }, {
    key: "nuke",
    value: function nuke() {
      this.listeners.clear();
      var list = omnibusLines.get(this.name);

      if (list === null || list === void 0 ? void 0 : (0, _includes.default)(list).call(list, this)) {
        (0, _splice.default)(list).call(list, (0, _indexOf.default)(list).call(list, this), 1);
        omnibusLines.set(this.name, list);
      }
    }
  }]);
  return OmnibusLine;
}();

exports.OmnibusLine = OmnibusLine;

function omnibus(line) {
  var _omnibusLines$get2;

  var list = (_omnibusLines$get2 = omnibusLines.get(line)) !== null && _omnibusLines$get2 !== void 0 ? _omnibusLines$get2 : [];
  var lineDefinition = new OmnibusLine(line);
  list.push(lineDefinition);
  omnibusLines.set(line, list);
  return lineDefinition;
}
